var exports = {
  "AS": "x28a7bf27--ca6797--item",
  "UU": "x28a7bf27--ca6797--name",
  "h_": "x28a7bf27--ca6797--description",
  "uH": "x28a7bf27--ca6797--condition",
  "UE": "x28a7bf27--ca6797--arrow",
  "sz": "x28a7bf27--ca6797--expanded",
  "wx": "x28a7bf27--ca6797--header",
  "nM": "x28a7bf27--ca6797--row",
};

module.exports = exports;
